import styled from '@emotion/styled'

import TemplateHeader from '@/components/templates/TemplateHeader'
import TemplateNavigation from '@/components/templates/TemplateNavigation'

const Layout = styled.div``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  background-color: white;
  width: 100%;
  height: 80px !important;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 900 !important;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
`

export default Layout
